import React, { FunctionComponent } from 'react'
import styles from './ArchiveDialog.module.sass'
import { Dialog } from '../../../../etc/Dialog/Dialog'
import ArchiveIcon from 'files/archive/archive.svg'
import { useDerivedState, useRootSelector } from '../../../../../utils/hooks'
import { ID } from '../../../../../types/UtilityTypes'
import { Classes, Colors } from '../../../../../styles'
import Spacer from '../../../../etc/Spacer'
import { projectDeclination, toggle } from '../../../../../utils/utils'
import ProjectLine from '../../../projects/ProjectList/ProjectLine/ProjectLine'
import { Checkbox } from '../../../../controls/Checkbox/Checkbox'
import * as A from 'fp-ts/Array'
import { eqId } from '../../../../../utils/entity-utils'
import { monoidSum } from 'fp-ts/Monoid'
import fileSize from 'filesize'
import OkCancel from '../../../../controls/OkCancel/OkCancel'
import { identity, pipe } from 'fp-ts/function'
import { projectsSelector } from '../../../../../utils/selectors'

interface Props {
    projects: ID[],
    onArchive: (ids: ID[]) => void,
    onClose: () => void,
}

const ArchiveDialog: FunctionComponent<Props> = props => {
    const projects = useRootSelector(projectsSelector(props.projects))
    const [selected, setSelected] = useDerivedState<ID[]>(props.projects)

    const total = pipe(
        projects,
        A.filter(project => A.elem(eqId)(project.id, selected)),
        A.map(project => project.size),
        A.foldMap(monoidSum)(identity)
    )

    return <Dialog
        className={styles.dialog}
        headerClassName={styles.header}
        actionsClassName={styles.actions}
        contentClassName={styles.content}
        upheader={'При необходимости измените выбор'}
        header={'Архивировать проекты'}
        onClose={props.onClose}
        actions={({onClose}) => <>
            <div>
                <div>Будет заархивировано: <span className={Classes.cPurpleLight}>
                    {projectDeclination(selected.length)}
                </span></div>
                <div>Освободится на рабочем диске: <span className={Classes.cPurpleLight}>
                    {fileSize(total)}
                </span></div>
            </div>
            <Spacer/>
            <OkCancel
                color={Colors.purpleMedium}
                text={'Архивировать'}
                icon={<ArchiveIcon/>}
                onCancel={onClose}
                onOk={() => props.onArchive(selected)}
            />
        </>}
    >
        {
            projects.map((project) => <ProjectLine
                key={project.id}
                minimal
                projectId={project.id}
                control={() => <Checkbox
                    color={Colors.purpleLight}
                    value={A.elem(eqId)(project.id, selected)}
                    onChange={() => setSelected(toggle(eqId)(project.id))}
                />}
            >
                <div className={Classes.cPurpleLight}>{fileSize(project.size)}</div>
            </ProjectLine>)
        }
    </Dialog>
}

export default ArchiveDialog